import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Default } from "../../components/Default/Default";
import { PlanoDeCompraSection } from "./components/PlanoDeCompraSection";
import { useOtbViewModel } from "../../viewModel/useOtbVewModel";
import { SYSTEM_COLORS } from "../../components/system.colors";

export function PlanoDeCompraScreen() {

  const location = useLocation();
  const initialFilter = location.state?.initialFilter;

  const [expandedProduct, setExpandedProduct] = useState(null);

  const vm_otb = useOtbViewModel({
    shouldFetchSalesPlan: true,
    productHierarchyNodeId: expandedProduct?.productHierarchyNodeId,
    parentLevelId: expandedProduct?.parentLevelId,
  });

  return (
    <Default fullPage>
      <div style={{
        padding: "24px 32px", backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        display: "flex", flexDirection: "column", flex: 1, minHeight: 0,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box", width: "calc(100% - 72px)", overflow: "auto",
        marginLeft: 72,
      }}>
        <PlanoDeCompraSection
          actions={{ onExpandProduct: setExpandedProduct }}
          ctx={{
            salesPlanData: vm_otb?.ctx?.otbSalesPlan,
            categoryHierarchy: vm_otb?.ctx?.categoryHierarchyOnSalesPlan,
            detailedData: vm_otb?.ctx?.otbSalesPlanDetailed,
            brands: vm_otb?.ctx?.brands,
            initialFilter,
          }}
          uiState={{
            isLoadingOtbSalesPlan: vm_otb?.uiState?.isLoadingOtbSalesPlan,
            isLoadingDetailed: vm_otb?.uiState?.isLoadingOtbSalesPlanDetailed,
          }}
        />
      </div>
    </Default>
  );
}